import { render } from "./StoreReportDesignerView.vue?vue&type=template&id=0506031a&scoped=true"
import script from "./StoreReportDesignerView.vue?vue&type=script&lang=js"
export * from "./StoreReportDesignerView.vue?vue&type=script&lang=js"

import "./StoreReportDesignerView.vue?vue&type=style&index=0&id=0506031a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0506031a"]])

export default __exports__